/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExternalNotificationEventType {
    All = 0,
    ShiftPlanNotification = 1,
    ShiftNotPlannedNotification = 2,
    VarianceReportNotification = 3,
    ShiftPlanNotPrinted = 4,
}
